import { render } from "./X6.vue?vue&type=template&id=5d271bf6"
import script from "./X6.vue?vue&type=script&lang=js"
export * from "./X6.vue?vue&type=script&lang=js"

import "./X6.vue?vue&type=style&index=0&id=5d271bf6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__